import { render, staticRenderFns } from "./ContrapartidaField.vue?vue&type=template&id=1a08c7eb&scoped=true&"
import script from "./ContrapartidaField.vue?vue&type=script&lang=js&"
export * from "./ContrapartidaField.vue?vue&type=script&lang=js&"
import style0 from "./ContrapartidaField.vue?vue&type=style&index=0&id=1a08c7eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08c7eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
